import {
    UPDATE_EMPLOYEE_BIDDING_RESULTS_REPORT,
    RESET_EMPLOYEE_BIDDING_RESULTS_REPORT,
} from './employeeBiddingResultsReport.actions';
import { ShiftDisplayType } from '../../Enums';

/** @type {EmployeeBiddingResultsReport.IEmployeeBidResultReport} */
const initialState = {
    preparedEmployeeResults: [],
    shifts: {},
    paycodes: {},
    filters: {
        search: '',
        employees: [],
        selectedEmployees: [],
    },
    pagination: {
        pageIndex: 0,
        pageSize: 10,
        totalCount: 0,
    },
    sort: {
        sortColumn: 0,
        isSortAscending: true,
    },
    shiftDisplayType: ShiftDisplayType.ShiftLabel,
};

/**
 *
 * @param {EmployeeBiddingResultsReport.IEmployeeBidResultReport} state
 * @param {ShiftBidding.IAction} action
 */
// eslint-disable-next-line default-param-last
export default function employeeBiddingResultsReportReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case UPDATE_EMPLOYEE_BIDDING_RESULTS_REPORT:
            return {
                ...state,
                ...payload,
            };
        case RESET_EMPLOYEE_BIDDING_RESULTS_REPORT:
            return initialState;
        default:
            return state;
    }
}
